import type { ReactNode } from 'react';

const FORMATTING_PATTERN = /(\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~)/g;

function renderPart(part: string, index: number): ReactNode {
  if (index % 2 === 0) return part;

  const key = `${index}-${part}`;
  const inner = part.slice(1, -1);
  if (part.startsWith('*')) return <strong key={key}>{inner}</strong>;
  if (part.startsWith('_')) return <em key={key}>{inner}</em>;

  return <s key={key}>{inner}</s>;
}

export function formatWhatsappText(text = ''): ReactNode[] {
  return String(text || '')
    .split(FORMATTING_PATTERN)
    .map(renderPart)
    .filter((part) => part !== '');
}
